/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectValidationRequirementType = {
    PrePaymentNotPaid: 'PRE_PAYMENT_NOT_PAID',
    FreelancerInvoicesNotAllowed: 'FREELANCER_INVOICES_NOT_ALLOWED'
} as const;
export type ProjectValidationRequirementType = typeof ProjectValidationRequirementType[keyof typeof ProjectValidationRequirementType];


export function instanceOfProjectValidationRequirementType(value: any): boolean {
    for (const key in ProjectValidationRequirementType) {
        if (Object.prototype.hasOwnProperty.call(ProjectValidationRequirementType, key)) {
            // @ts-ignore
            if (ProjectValidationRequirementType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectValidationRequirementTypeFromJSON(json: any): ProjectValidationRequirementType {
    return ProjectValidationRequirementTypeFromJSONTyped(json, false);
}

export function ProjectValidationRequirementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectValidationRequirementType {
    return json as ProjectValidationRequirementType;
}

export function ProjectValidationRequirementTypeToJSON(value?: ProjectValidationRequirementType | null): any {
    return value as any;
}

